document.addEventListener("DOMContentLoaded", function() {
            // Function to get URL parameters
            function getUrlParams() {
                const params = {};
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                urlParams.forEach((value, key) => {
                    params[key] = value;
                });
                return params;
            }

            // Function to populate form fields with URL parameters
            function populateFormFields(params) {
                for (const key in params) {
                    if (params.hasOwnProperty(key)) {
                        const field = document.querySelector(`[name="${key}"]`);
                        if (field) {
                            field.value = params[key];
                        }
                    }
                }
            }

            // Get URL parameters and populate form fields
            const urlParams = getUrlParams();
            populateFormFields(urlParams);
        });